import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value", "onChange", "debounce"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Input, forwardRef } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { useDebounceCallback } from 'usehooks-ts';
import { jsx as _jsx } from "react/jsx-runtime";
var DebouncedInput = forwardRef(function (_ref, ref) {
  var initialValue = _ref.value,
      onChange = _ref.onChange,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 350 : _ref$debounce,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(initialValue),
      value = _useState[0],
      setValue = _useState[1];

  useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);
  var debouncedOnChange = useDebounceCallback(onChange, debounce);
  var handleChange = useCallback(function (e) {
    var value = e.target.value;
    setValue(value);
    debouncedOnChange(value, e);
  }, [debouncedOnChange]);
  return /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({}, props), {}, {
    value: value,
    onChange: handleChange,
    ref: ref,
    e2eid: "components_DebouncedInput_Input"
  }));
}); // fix for built-in chakra input behavior
// reference: https://github.com/chakra-ui/chakra-ui/issues/2269#issuecomment-1502538404

DebouncedInput.id = 'Input';
export default DebouncedInput;